module.exports = __webpack_public_path__ + "img/patrulla_dif_up.6b069962.svg";